import { EXPERIMENTS } from '@fiverr-private/listing_experiments';

export const isInHourlyToggleExperiment = (clientExperimentsGroups: Record<string, number> = {}): boolean => {
    const experimentGroup = Number(clientExperimentsGroups[EXPERIMENTS.COBRAS_HOURLY_FILTER_EXPOSURE]);
    return experimentGroup > 1;
};
